// eslint-disable-next-line import/prefer-default-export
export const getOrderType = (transType: number): OrderType => {
    const isBuy = transType === 0 || transType === 11 || transType === 20
    return isBuy ? "buy" : "sell"
}

export const isMarketOrder = (taker: number): boolean => taker === 1
